import type { FC } from 'react';
import type { ValidateResult } from 'react-hook-form';

import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { atLeastOneValidatorFunction } from '@/services/validators';

export function withAtLeastOneValidation( WrappedComponent: FC<ValidatedComponentProps> ) {
	const NewComponent = ( props: ValidatedComponentProps ) => {
		const { question, validators } = props;

		const { getValues, setError } = useFormContext();

		const atLeastOneValidators = useMemo( () => {
			return validators.filter( validator => validator.fieldType === 'RequireAtLeastOne' );
		}, [ validators ] );

		const validationObject = useMemo( () => {
			const returnValue: Record<string, ( v: string ) => ValidateResult> = { ...question.validate };

			if ( atLeastOneValidators.length === 0 ) {
				return returnValue;
			}

			returnValue[ 'atLeastOne' ] = ( v: string ) => {
				return atLeastOneValidatorFunction( atLeastOneValidators as ValidationRequireAtLeastOne[], question, v, getValues, setError );
			};

			return returnValue;
		}, [ atLeastOneValidators, getValues, question, setError ] );

		return (
			<div>
				<WrappedComponent
					{ ...props }
					question={{
						...question,
						validate: validationObject
					}}
				/>
			</div>
		);
	};

	NewComponent.displayName = 'withAtLeastOneValidation';

	return NewComponent;
}
